module.exports = __webpack_public_path__ + "static/mark-0e418366d22b6b35bdf35f89f20a7e33.png";